import React from 'react'
import { render } from 'react-dom'
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux'

import 'bootstrap/dist/css/bootstrap.css'
import './index.css'

import App from './App'
import createStore from './store/store'

const { store, persistor } = createStore()

render(
	<Provider store={store}>
		<PersistGate persistor={persistor}>
			<App />
		</PersistGate>
	</Provider>,
	document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js